<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'xl'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <CRow>
        <CCol>
          <div class="table-responsive">
            <table id="dataTableLists"
              class="table table-sm table-hover table-striped table-bordered dt-responsive nowrap" style="width: 100%">
              <thead>
                <tr>
                  <th width="60">Cita</th>
                  <th>Fecha de Cita</th>
                  <th>Personal</th>
                  <th>Cliente</th>
                  <th>Servicio</th>
                  <th>Descripción del Servicio</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(quote, index) in item" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ formatDate(quote.date) }}</td>
                  <td> {{ name_barber }}</td>
                  <td>{{ quote.name_client }}</td>
                  <td>
                    <ul v-for="(detail, deIndex) in quote.barber_detail.filter(d => d.barber_id == barber_id)"
                      :key="deIndex">
                      <li v-for="(service, sIndex) in JSON.parse(detail.services_ids)" :key="sIndex">
                        {{ service.label }} ({{ service.quantity }})
                      </li>
                    </ul>
                  </td>
                  <td>
                    <template
                      v-if="quote.barber_detail.filter(d => d.barber_id == barber_id && d.detail_service != null).length > 0">
                      <ul v-for="(detail, dIndex) in quote.barber_detail.filter(d => d.barber_id == barber_id)"
                        :key="dIndex">
                        <li>
                          {{ detail.detail_service }}
                        </li>
                      </ul>
                    </template>
                  </td>
                  <td>
                    {{
                      quote.barber_detail
                        .filter(d => d.barber_id == barber_id)
                        .reduce((sum, detail) => {
                          const services = JSON.parse(detail.services_ids || "[]");
                          return sum + services.reduce((serviceSum, service) => serviceSum + (service.price *
                            service.quantity), 0);
                        }, 0).toFixed(2)
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="text-end"><strong>Total:</strong></td>
                  <td><strong>{{ totalSum }}</strong></td>
                </tr>

                <tr>
                  <td colspan="6" class="text-end">
                    <strong>Porcentaje ({{ barberPercentage }}%):</strong>
                  </td>
                  <td></td>
                </tr>

                <tr>
                  <td colspan="6" class="text-end">
                    <strong>Ganancia del Personal:</strong>
                  </td>
                  <td>
                    <strong>{{ barberEarnings }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
    </template>
  </CModal>

</template>
<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "c-reportquote-modal",
  components: {
    CModal,
  },
  data() {
    return {
      swal: null,
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    item: {
      type: Array,
      default: []
    },
    name_barber: String,
    barber_id: {
      type: Number,
      default: 0
    }
  },
  computed: {
    totalSum() {
      return this.item.reduce((sum, quote) => {
        const totalPerQuote = quote.barber_detail
          .filter(d => d.barber_id == this.barber_id)
          .reduce((detailSum, detail) => {
            const services = JSON.parse(detail.services_ids || "[]");
            return detailSum + services.reduce((serviceSum, service) => serviceSum + (service.price * service.quantity), 0);
          }, 0);
        return sum + totalPerQuote;
      }, 0).toFixed(2);
    },
    barberPercentage() {
      if (!this.item.length) return 0;

      // Buscar el primer detail que tenga el barber correcto
      for (const quote of this.item) {
        const detail = quote.barber_detail.find(
          d => d.barber_id == this.barber_id
        );

        if (detail && detail.barber) {
          return detail.barber.percentage ?? 0;
        }
      }

      return 0;
    },

    barberEarnings() {
      const total = parseFloat(this.totalSum);
      const percentage = this.barberPercentage;

      return (total * (percentage / 100)).toFixed(2);
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModalReportQuote");
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  },
}
</script>